import { Types } from 'mongoose';
import * as dis2 from '../../dispossitions/dispossitions.data';
import { ACTIVITY_TYPE_TRAINING, ACTIVITY_TYPE_TRAINING_ID } from './../activity-type.const';
import { COACH_PAYMENT, OTHER_FEE, TRAINER_PAYMENT, TRAINING_FEE } from './../payamnets.data';
import {
    ADVANCE_TRAINING_ID,
    ADVANCE_TRAINING_LABEL,
    BASIC_MEDIATION_TRAINING_ID,
    BASIC_MEDIATION_TRAINING_LABEL,
    CONFLICT_COUCHING_TRAINING_ID,
    CONFLICT_COUCHING_TRAINING_LABEL,
    // MENTORING_LABEL,
    OTHER_TRAINING_ID,
    OTHER_TRAINING_LABEL,
    PEER_MEDIATION_ID,
    PEER_MEDIATION_LABEL,
    // PROF_LERNING_COM_LABEL,
    REST_PRA_TRAINING_ID,
    REST_PRA_TRAINING_LABEL,
    SKILL_BUILDING_ID,
    SKILL_BUILDING_LABEL
} from './training.const';

const BASIC_MEDIATION = {
    _id: new Types.ObjectId(BASIC_MEDIATION_TRAINING_ID),
    label: BASIC_MEDIATION_TRAINING_LABEL,
    description: 'Basic Mediation Training',
    defaultDisposition: dis2.TR_BM_OPEN_PENDING,
    dispositions: [dis2.TR_BM_OPEN_PENDING, dis2.TR_BM_COMPLETED, dis2.TR_BM_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

const PEER_MEDIATION = {
    _id: new Types.ObjectId(PEER_MEDIATION_ID),
    label: PEER_MEDIATION_LABEL,
    description: 'Peer Mediation Training',
    defaultDisposition: dis2.TR_PM_OPEN_PENDING,
    dispositions: [dis2.TR_PM_OPEN_PENDING, dis2.TR_PM_COMPLETED, dis2.TR_PM_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

const REST_PRA = {
    _id: new Types.ObjectId(REST_PRA_TRAINING_ID),
    label: REST_PRA_TRAINING_LABEL,
    description: 'Restorative Practices Training',
    defaultDisposition: dis2.TR_RP_OPEN_PENDING,
    dispositions: [dis2.TR_RP_OPEN_PENDING, dis2.TR_RP_COMPLETED, dis2.TR_RP_OTHER],
    paymentIn: [OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

const SKILL_BUILDING = {
    _id: new Types.ObjectId(SKILL_BUILDING_ID),
    label: SKILL_BUILDING_LABEL,
    description: 'Skills-based, practice focused workshops',
    defaultDisposition: dis2.TR_SBW_OPEN_PENDING,
    dispositions: [dis2.TR_SBW_OPEN_PENDING, dis2.TR_SBW_COMPLETED, dis2.TR_SBW_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};
const ADVANCE_TRAINING = {
    _id: new Types.ObjectId(ADVANCE_TRAINING_ID),
    label: ADVANCE_TRAINING_LABEL,
    description: 'Any training that builds on Basic Mediation Training skills',
    defaultDisposition: dis2.TR_AT_OPEN_PENDING,
    dispositions: [dis2.TR_AT_OPEN_PENDING, dis2.TR_AT_COMPLETED, dis2.TR_AT_OTHER],
    paymentIn: [TRAINING_FEE],
};

// const MENTORING = {
//     _id: new Types.ObjectId(MENTORING_ID),
//     label: MENTORING_LABEL,
//     paymentIn: [TRAINING_FEE, OTHER_FEE],
//     paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
// };

// const PROF_LERNING_COM = {
//     _id: new Types.ObjectId(PROF_LERNING_COM_ID),
//     label: PROF_LERNING_COM_LABEL,
//     paymentIn: [TRAINING_FEE, OTHER_FEE],
//     paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
// };

const CONFLICT_COUCHING_TRAINING = {
    _id: new Types.ObjectId(CONFLICT_COUCHING_TRAINING_ID),
    label: CONFLICT_COUCHING_TRAINING_LABEL,
    description: 'Conflict Coaching Training',
    defaultDisposition: dis2.TR_CC_OPEN_PENDING,
    dispositions: [dis2.TR_CC_OPEN_PENDING, dis2.TR_CC_COMPLETED, dis2.TR_CC_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

const OTHER_TRAINING = {
    _id: new Types.ObjectId(OTHER_TRAINING_ID),
    label: OTHER_TRAINING_LABEL,
    description: '',
    defaultDisposition: dis2.TR_OTH_OPEN_PENDING,
    dispositions: [dis2.TR_OTH_OPEN_PENDING, dis2.TR_OTH_COMPLETED, dis2.TR_OTH_OTHER],
    paymentIn: [TRAINING_FEE, OTHER_FEE],
    paymentOut: [OTHER_FEE, TRAINER_PAYMENT, COACH_PAYMENT],
};

export const TRAINING = {
    _id: new Types.ObjectId(ACTIVITY_TYPE_TRAINING_ID),
    icon: 'training',
    label: ACTIVITY_TYPE_TRAINING,
    description: 'Activities that teach knowledge and skills',
    subTypes: [
        BASIC_MEDIATION,
        PEER_MEDIATION,
        REST_PRA,
        SKILL_BUILDING,
        ADVANCE_TRAINING,
        // MENTORING,
        CONFLICT_COUCHING_TRAINING,
        // PROF_LERNING_COM,
        OTHER_TRAINING,
    ],
};
